import * as React from 'react';

function HealthAndSafetyIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M12 9v4m0 4h.01m9.72 1l-8-14a2 2 0 00-3.48 0l-8 14A2 2 0 004 21h16a2.001 2.001 0 001.73-3z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default HealthAndSafetyIcon;
